import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#0369a1", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#e0f2fe", border: "1px solid #bae6fd", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#0c4a6e", lineHeight: 1.6 },
}));

const DEFAULT = { cpfVar: "cpf" };

const FlowBuilderSgpConsultaModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ cpfVar: data.data.data.cpfVar || "cpf" });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    if (open === "edit") {
      onUpdate(data.id, { data: { label: `Consultar {{${cfg.cpfVar}}}`, data: cfg } });
    } else {
      onSave({ label: `Consultar {{${cfg.cpfVar}}}`, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>SGP — Consultar Cliente</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Consulta o cliente pelo CPF/CNPJ armazenado em uma variável do fluxo.<br />
            Salva automaticamente: <strong>sgp_nome</strong>, <strong>sgp_cliente_id</strong>,{" "}
            <strong>sgp_contrato_id</strong>, <strong>sgp_plano</strong>,{" "}
            <strong>sgp_faturas_count</strong>, <strong>sgp_faturas_json</strong>.
          </Typography>
        </Box>

        <TextField
          label="Variável com CPF/CNPJ"
          value={cfg.cpfVar}
          onChange={(e) => setCfg({ ...cfg, cpfVar: e.target.value })}
          fullWidth margin="dense" variant="outlined"
          helperText={`Nome da variável que contém o CPF/CNPJ. Ex: cpf → usa {{cpf}}`}
        />

        <Box style={{ marginTop: 16, padding: 12, background: "#f0f9ff", borderRadius: 8, border: "1px solid #bae6fd" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#0c4a6e", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#0369a1" }}>
            🟢 <strong>encontrado</strong> — cliente localizado no SGP<br />
            🟡 <strong>nao_encontrado</strong> — CPF não cadastrado<br />
            🔴 <strong>erro</strong> — falha de API ou credenciais
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSgpConsultaModal;
